import { create } from "zustand";

/** Estado global del tutorial de inicio (tour guiado).
 *  Lo activa AppShell en el primer login o el botón "?" del TopBar. */
interface TourState {
  active: boolean;
  step: number;
  start: () => void;
  stop: () => void;
  setStep: (n: number) => void;
}

export const useTourStore = create<TourState>(set => ({
  active: false,
  step: 0,
  start: () => set({ active: true, step: 0 }),
  stop: () => set({ active: false, step: 0 }),
  setStep: (n: number) => set({ step: n }),
}));

export const tourDoneKey = (email: string) => `hx_tour_done:${email}`;
